import React from 'react'
import { useStateValue } from '@State'
import PropTypes from 'prop-types'

export const ReviewButton = props => {
  const [currentState] = useStateValue()
  switch (currentState.exceptionType) {
    case 'grantExtraTime':
      return (
        <div>
          <div
            className="panel panel-default w-100 d-flex justify-content-left p-1"
            style={{ marginBottom: '7px', fontFamily: 'var(--font-ui)' }}
          >
            <span className="ml-2">{props.activity.title} |</span>
            <span
              className="ml-1 mr-2 text-danger"
              style={{ textDecoration: 'line-through' }}
            >
              {props.activity.rule_options.time_limit} minutes
            </span>
            <i className="fa-regular fa-arrow-right fa-xs mt-2 ml-1 mr-2" />
            <span className="text-success font-weight-bold">
              {!currentState.override
                ? props.activity.rule_options.time_limit +
                  Number(currentState.extraTime) +
                  ' minutes'
                : 'No time limit.'}
            </span>
          </div>
        </div>
      )
    case 'extendDueDate':
      return (
        <div>
          <div
            className="panel panel-default w-100 d-flex justify-content-left p-1"
            style={{ marginBottom: '7px', fontFamily: 'var(--font-ui)' }}
          >
            <span className="ml-2">{props.activity.title} |</span>
            <span
              className="ml-1 mr-2 text-danger"
              style={{ textDecoration: 'line-through' }}
            >
              {formatDueDate(props.activity.rule_options.due_date, 0, 0, 0)}
            </span>
            <i className="fa-regular fa-arrow-right fa-xs mt-2 ml-1 mr-2" />
            <span className="text-success font-weight-bold">
              {!currentState.override
                ? formatDueDate(
                    props.activity.rule_options.due_date,
                    currentState.shiftDays,
                    currentState.shiftHours,
                    currentState.shiftMinutes
                  )
                : 'No due date.'}{' '}
            </span>
          </div>
        </div>
      )
  }
}

const formatDueDate = (dueDateString, shiftDays, shiftHours, shiftMinutes) => {
  const dueDate = new Date(dueDateString)
  dueDate.setDate(dueDate.getDate() + Number(shiftDays))
  dueDate.setHours(
    dueDate.getHours() + Number(shiftHours),
    dueDate.getMinutes() + Number(shiftMinutes)
  )
  const displayDueDateTime = dueDate.toString().split(' ', 5)[4]
  const month = dueDate.getMonth()
  const date = dueDate.getDate()
  const year = dueDate.getFullYear()
  function pad(n) {
    return n < 10 ? '0' + n : n
  }
  const mmddyyyy = pad(month + 1) + '/' + pad(date) + '/' + year
  return mmddyyyy + ' ' + displayDueDateTime
}

ReviewButton.propTypes = {
  activity: PropTypes.object.isRequired,
}
